import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import './styles.css';
// Dark unless the creator chose light (App.tsx theme switch); set before the first paint.
document.documentElement.dataset['theme'] =
  localStorage.getItem('partner.theme') === 'light' ? 'light' : 'dark';
createRoot(document.getElementById('root')!).render(<App />);
